// src/api/invoiceSupplierConfigApi.js
import axiosClient from "./axiosClient";

const invoiceSupplierConfigApi = {
  SearchInvoiceSupplierConfig: (CusId) => {
    return axiosClient.get(`/invoice_supplier_configs/search/${CusId}`, {
      withCredentials: true,
    });
  },
  UpsertInvoiceSupplierConfig: (data) => {
    return axiosClient.post("/invoice_supplier_configs/upsert", data, {
      withCredentials: true,
    });
  },
  DeleteInvoiceSupplierConfig: (IscId) => {
    return axiosClient.delete(`/invoice_supplier_configs/${IscId}`, {
      withCredentials: true,
    });
  },
  ChooseInvoiceSupplierConfig: (IscId) => {
    return axiosClient.put(
      `/invoice_supplier_configs/choose-config/${IscId}`,
      {},
      {
        withCredentials: true,
      }
    );
  },
  GetInvoiceSupplierConfig: (IscId) => {
    return axiosClient.get(`/invoice_supplier_configs/${IscId}`, {
      withCredentials: true,
    });
  },
  GetInvoiceSupplierConfigActive: (customerId) => {
    return axiosClient.get(
      `/invoice_supplier_configs/get-active/${customerId}`,
      {
        withCredentials: true,
      }
    );
  },
};

export default invoiceSupplierConfigApi;
